"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Card = function Card(_ref) {
  var children = _ref.children,
      header = _ref.header,
      isMinimal = _ref.isMinimal,
      className = _ref.className,
      style = _ref.style;
  return _react["default"].createElement("div", {
    className: "card ".concat(className).concat(isMinimal ? ' card-minimal' : ''),
    style: style
  }, header && _react["default"].createElement("div", {
    className: "card-header"
  }, header), _react["default"].createElement("div", {
    className: "card-block"
  }, children));
};

Card.propTypes = {
  children: _propTypes["default"].node.isRequired,
  header: _propTypes["default"].node,
  isMinimal: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _reactStyleProptype["default"]
};
Card.defaultProps = {
  header: undefined,
  isMinimal: false,
  className: '',
  style: {}
};
var _default = Card;
exports["default"] = _default;